import {
    CASOSDETALLES_LIST,
    CASOSDETALLES_LISTA,
    CASOSDETALLES_FILTER,
    CASOSDETALLES_CREATE,
    CASOSDETALLES_CREATE_SUCCESS,
    CASOSDETALLES_LIST_SUCCESS,
    CASOSDETALLES_REQUEST_FAILED,
    CASOSDETALLES_UPDATE,
    CASOSDETALLES_UPDATE_SUCCESS,
    CASOSDETALLES_READ,
    CASOSDETALLES_READ_SUCCESS,
  } from "./actionTypes";
  
  const initialState = {
    casosDetalles: [],
    casosDetallesCreated: {},
    casosDetallesUpdated: {},
    loading: false,
    error: "",
  };
  
  const casosDetalles = (state = initialState, action) => {
    switch (action.type) {
      case CASOSDETALLES_CREATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case CASOSDETALLES_LIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case CASOSDETALLES_LISTA:
        state = {
          ...state,
          loading: true,
        };
        break;
      case CASOSDETALLES_FILTER:
        state = {
          ...state,
          loading: true,
        };
        break;
        case CASOSDETALLES_READ:
          state = {
            ...state,
            loading: true,
          };
          break;
          case CASOSDETALLES_CREATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          casosDetallesCreated: action.payload,
          error: "",
        };
        break;
      case CASOSDETALLES_UPDATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case CASOSDETALLES_READ_SUCCESS:
        state = {
          ...state,
          loading: false,
          casosDetalles: action.payload,
          error: "",
        };
        break;
      case CASOSDETALLES_LIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          casosDetalles: action.payload,
          casosDetallesCreated: {},
          casosDetallesUpdated: {},
          error: "",
        };
        break;
      case CASOSDETALLES_UPDATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          casosDetallesUpdated: action.payload,
          error: "",
        };
        break;
      case CASOSDETALLES_REQUEST_FAILED:
        state = {
          ...state,
          loading: false,
          error: action.payload,
        };
        break;
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default casosDetalles;
  